import * as React from 'react';
import { Alert } from '../../components/Bootstrap';
import { getAPIDisplayTitleAndMessage } from '../../utils/error';

type ErrorAlertProps = {
  error: Error | null;
  onClear?();
};

export const ErrorAlert: React.FC<ErrorAlertProps> = ({ error: errorProp, onClear }) => {
  const [error, setError] = React.useState<Error | undefined>(undefined);
  const lastError = React.useRef(errorProp);

  React.useEffect(() => {
    if (errorProp !== lastError.current && errorProp) {
      setError(errorProp);
    }

    lastError.current = errorProp;
  }, [errorProp, setError]);

  const hideError = React.useCallback(() => {
    setError(undefined);
    if (onClear) {
      onClear();
    }
  }, [onClear]);

  if (!error) {
    return null;
  }

  const { title, message, traceId } = getAPIDisplayTitleAndMessage(error); //?? {};

  return (
    <Alert color='danger' isOpen={true} toggle={hideError}>
      <h4 className='alert-heading'>{title ?? 'Sorry, something went wrong'}</h4>
      <div dangerouslySetInnerHTML={{ __html: message }} />
      {traceId && <small className='mt-3'>Service ID: {traceId}</small>}
    </Alert>
  );
};
